import { Reveal, Eyebrow } from "./Reveal";

const BLUEPRINT_IMG =
  "https://images.unsplash.com/photo-1503387837-b154d5074bd2?auto=format&fit=crop&w=1200&q=80";
const CREW_IMG =
  "https://images.unsplash.com/photo-1593313637552-29c2c0dacd35?auto=format&fit=crop&w=1200&q=80";

const STEPS = [
  {
    num: "01",
    title: "Free Inspection",
    desc: "We inspect your roof and exterior for visible storm damage — thoroughly, honestly, and at no cost to you.",
  },
  {
    num: "02",
    title: "Documentation",
    desc: "We document relevant damage with photos and detail, and provide a clear, written estimate for the work.",
  },
  {
    num: "03",
    title: "Insurance Process",
    desc: "We help you understand the restoration process every step of the way. Insurance coverage and claim decisions are determined by your policy and your insurance carrier.",
  },
  {
    num: "04",
    title: "Restoration",
    desc: "We complete the approved roofing, siding, gutter, or exterior restoration work with quality workmanship — above the rest, every time.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative border-t border-white/10 py-28 md:py-40"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid gap-16 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Eyebrow>Retail &amp; Insurance Restoration</Eyebrow>
              <h2 className="mt-6 font-serif text-5xl font-medium leading-[1.02] tracking-tight md:text-6xl">
                Two Paths.
                <br />
                <span className="italic text-gold">One Standard of Care.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-8 text-sm leading-relaxed text-white/60 md:text-base">
                <span className="font-semibold text-white">Planning a project?</span> Retail
                homeowners count on us for planned roofing, siding, and gutter work — honest
                pricing, premium materials, and zero pressure from first call to final walkthrough.
              </p>
              <p className="mt-5 text-sm leading-relaxed text-white/60 md:text-base">
                <span className="font-semibold text-white">Hit by a storm?</span> For
                storm-damaged properties, we walk with you from the first inspection to the final
                shingle — documenting damage, providing clear estimates, and restoring your home
                with excellence.
              </p>
            </Reveal>
            <Reveal delay={0.2} className="relative mt-12 hidden lg:block">
              <div className="overflow-hidden border border-white/10">
                <img
                  src={BLUEPRINT_IMG}
                  alt="Detailed inspection planning"
                  className="h-64 w-full object-cover opacity-70 transition-transform duration-700 hover:scale-[1.03]"
                />
              </div>
              <div className="absolute -bottom-10 -right-6 hidden w-52 overflow-hidden border border-gold/30 xl:block">
                <img
                  src={CREW_IMG}
                  alt="Restoration crew at work"
                  className="h-36 w-full object-cover"
                />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="border-t border-white/10">
              {STEPS.map((step, i) => (
                <Reveal key={step.num} delay={i * 0.08}>
                  <div
                    data-testid={`process-step-${i + 1}`}
                    className="group grid grid-cols-[auto_1fr] gap-6 border-b border-white/10 py-10 md:gap-12 md:py-12"
                  >
                    <span className="text-outline font-serif text-6xl font-semibold leading-none md:text-7xl">
                      {step.num}
                    </span>
                    <div>
                      <h3 className="font-serif text-2xl font-medium tracking-tight text-white transition-colors duration-300 group-hover:text-gold md:text-3xl">
                        {step.title}
                      </h3>
                      <p className="mt-3 max-w-lg text-sm leading-relaxed text-white/55">
                        {step.desc}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.2}>
              <p
                data-testid="process-insurance-disclaimer"
                className="mt-8 border border-gold/25 bg-gold/5 p-6 text-xs leading-relaxed text-white/55"
              >
                Please note: insurance coverage and claim decisions are determined solely by the
                homeowner's policy and insurance carrier. Seraph Roofing provides inspections,
                documentation, estimates, and quality restoration work — and communicates with
                honesty at every step.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
